
import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  FutureLayerAISettings,
  getFutureLayerAISettings,
  saveFutureLayerAISettingsToGlobalStoreAndWordPress
} from "@/futurelayer/settings/settings";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import TopNavSave from "../TopNav/TopNavSave.vue";

@Component({
  components: {
    TextInput,

    TopNavSave
  }
})
export default class Settings extends Vue {
  aiSettings: FutureLayerAISettings = {
    title: "",
    description: ""
  };

  mounted() {
    this.aiSettings = getFutureLayerAISettings();
  }

  saveInProgress = false;

  async saveSettings() {
    this.saveInProgress = true;
    await saveFutureLayerAISettingsToGlobalStoreAndWordPress(this.aiSettings);
    this.saveInProgress = false;
  }
}
